import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import styled from 'styled-components';
import DetectorController, { HotelListType } from '../../../controller/DetectorController';
import '../../../styles/CustomModal.css';

type MappingListType = {
  ad_started_at: string;
  address: string;
  distance: number;
  status: number;
  store_id: number;
  store_name: string;
  store_type: number;
  user_id: number;
};
interface AddMappingProps {
  selectStore: any;
  mappingList: MappingListType[];
  getMappingStore: any;
}
interface ChekItemProps {
  store_id: number;
  store_name: string;
  user_id: number;
}

const AddMapping = ({ selectStore, mappingList, getMappingStore }: AddMappingProps) => {
  const [checkedItems, setCheckedItems] = useState<ChekItemProps[]>([]);

  const handleHotelChange = (store: ChekItemProps, isChecked: boolean) => {
    const { store_id, user_id, store_name } = store;

    setCheckedItems((prev) =>
      isChecked
        ? [...prev, { store_id, user_id, store_name }]
        : prev.filter((item) => item.store_id !== store_id),
    );
  };

  const setMappingStore = async () => {
    try {
      const oData = {
        source: selectStore,
        target: checkedItems,
      };

      const response = await DetectorController.setMappingStore(oData);
      if (response && response.data.ok) {
        toast.success('맵핑 정보가 수정되었습니다.');
      } else {
        toast.error(response.data.msg);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  useEffect(() => {
    const initialCheckedItems = mappingList
      .filter((data) => data.status === 1)
      .map(({ store_id, user_id, store_name }) => ({ store_id, user_id, store_name }));

    setCheckedItems(initialCheckedItems);
  }, [mappingList]);

  return (
    <Style>
      <div className="detailListWrap">
        <h3>
          <strong>{selectStore.store_name}</strong>의 맵핑 정보를 선택해 주세요.
        </h3>
        <div className="content">
          <h4>맵핑 호텔 설정</h4>
          <div className="hotelListBox">
            {mappingList.map((data) => {
              return (
                <div className="hotelListWrap" key={data.store_id}>
                  <label>
                    <input
                      type="checkbox"
                      name="data"
                      value={data.store_id}
                      onChange={(e) => handleHotelChange(data, e.target.checked)}
                      checked={checkedItems.some((item) => item.store_id === data.store_id)}
                    />
                    <p>
                      {data.store_name}({data.distance}km)
                    </p>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <button className="submitButton" onClick={setMappingStore}>
          맵핑하기
        </button>
      </div>
    </Style>
  );
};

export default AddMapping;

const Style = styled.div`
  /* detailListWrap */
  .detailListWrap {
    margin-top: 30px;

    .content {
      margin: 60px 0;
      h4 {
        margin: 10px 0;
        color: #7a7a7a;
      }
    }
  }

  .dateWrap {
    margin-top: 30px;

    input {
      width: 40%;
    }
    p {
      width: 5%;
      white-space: nowrap;
    }
  }
  .dateWrap > div {
    margin-bottom: 10px;
  }
  .charge {
    p {
      margin-bottom: 16px;
    }
  }

  /* hotelListBox */
  .hotelListBox {
    width: 100% !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px 10px;
    outline: none;
    border: 1px solid #eee;
    border-radius: 10px;
    gap: 16px;

    label {
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 6px;
    }
    input {
      width: 18px;
      height: 18px;
      accent-color: #40977f;
    }
    p {
      margin: 0;
      padding: 0;
      white-space: nowrap;
      font-size: 16px;
    }
  }
  .hotelListWrap {
    width: 30%;
  }

  .hotelListWrap.disabled {
    input,
    label {
      cursor: not-allowed;
    }
    p {
      color: #ddd;
    }
  }

  /* masterWrap */
  .masterWrap {
    margin-bottom: 30px;

    input {
      width: 30%;
    }
    p {
      width: 7%;
      white-space: nowrap;
    }
  }

  .currentTime {
    background: gray;
  }
  .submitButton{
    position: fixed;
    bottom :10px;
    left: 0;
    right: 0;
    width: 92%!important;
    margin: 0 auto;
  }

  @media (max-width: 1000px) {
    .hotelListWrap {
      width: 100%;
    }
    .dateWrap,
    .masterWrap {
      input {
        flex: 1;
        font-size: 14px;
      }
      p {
        min-width: 50px;
      }
    }
  }
`;
